import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';

import './styles/Home.css';

const TermsOfUse = () => {
    
    const auth = useAuth();
    const navigate = useNavigate();

    return (
        <div>
            <iframe src="https://docs.google.com/document/d/e/2PACX-1vQ7fIYyy6mOCq6fMLzZYmmvVMQZFrCbY6mkmnfFOPHSYak_cufsWKgRRL1FyV6JUw/pub?embedded=true"
              width="800" height="1200"
            >
            </iframe>

            
        </div>

    )
}

export default TermsOfUse;